import React, { useEffect } from 'react';
import Header from './components/Header';
import Banner from './components/Banner';
import About from './components/About';
import Services from './components/Services';
import Projects from './components/Projects';
import WorkPlatforms from './components/WorkPlatforms';
import Testimonials from './components/Testimonials';
import Contact from './components/Contact';
import './App.css';

function App() {
  const isAdminPath = typeof window !== 'undefined' && window.location.pathname.startsWith('/admin');
  const apiBaseUrl = (process.env.REACT_APP_API_BASE_URL || '').replace(/\/$/, '');
  const adminUrl = `${apiBaseUrl}/admin/`;

  useEffect(() => {
    if (isAdminPath && apiBaseUrl) {
      window.location.replace(adminUrl);
    }
  }, [isAdminPath, apiBaseUrl, adminUrl]);

  if (isAdminPath) {
    return null;
  }

  return (
    <div className="App">
      <Header />
      <main>
        <Banner />
        <About />
        <Services />
        <Projects />
        <WorkPlatforms />
        <Testimonials />
        <Contact />
      </main>
    </div>
  );
}

export default App;

